import React from 'react';

const NoAccess = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center px-6">
      <h1 className="text-4xl font-bold text-red-600 mb-4">Access Restricted</h1>
      <p className="text-lg text-gray-700 max-w-lg">
        Mobile devices are not supported for this application.
        Please access the system using a desktop or laptop.
      </p>
    </div>
  );
};

export default NoAccess;
